import { $host } from "./index";
import { TPaginationArgs } from "./CourseService";
import { isAdmin, isTeacher } from "../helpers/role";

export class InfoService {
  static async getTeachersList(role: string, args: TPaginationArgs) {
    if (isAdmin(role)) {
      return await $host.get("/info/teachers", { params: args }); //user_admin_get_85
    }
    return {};
  }

  static async getStudentsList(
    id: number,
    role: string,
    args: TPaginationArgs,
  ) {
    if (isAdmin(role) || isTeacher(role)) {
      //user_teacher_get_84
      return await $host.get("/info/students/" + id.toString(), {
        params: args,
      });
    }
    return {};
  }

  static async getAnswersInfo(id: number, days: number) {
    return await $host.get("/info/answers/" + days + "/" + id);
  }

  static async getLearningInfo(id: string, days: number) {
    const result = await $host.get("/info/learning/" + days + "/" + id);
    (result.data as any[]).forEach((e: any, index) => (e.id = e.course_id));
    return result;
  }

  static async assignTeacher(userId: number, teacherId: string) {
    return await $host.put("/info/assign/teacher/" + userId + "/" + teacherId);
  }

  static async unAssignTeacher(userId: number, teacherId: string) {
    return await $host.delete(
      "/info/assign/teacher/" + userId + "/" + teacherId,
    );
  }

  static async assignCourse(userId: number, courseId: string) {
    return await $host.put("/info/assign/course/" + userId + "/" + courseId);
  }

  static async getAssignedCourses(userId: number) {
    return await $host.get("/info/assign/course/" + userId);
  }

  static async deleteCourse(userId: number, courseId: string) {
    return await $host.delete("/info/assign/course/" + userId + "/" + courseId);
  }

  static async getTeacherUsers() {
    return await $host.get("/info/teacher/userlist");
  }

  static async sendStatement() {
    return await $host.post("/statement");
  }
}
